export default "__VITE_ASSET__FwdRq3$R__"